import { T } from "../../styles/GlobalStyles";

/**
 * Pastille lumineuse accent avec glow pulse.
 * Usage : sidebar Insights, et tout futur indicateur "nouveau contenu IA".
 *
 * @param {number} size - Diamètre en px (défaut 6)
 * @param {boolean} visible - Si false, ne rend rien
 * @param {boolean} pulse - Si true, animation glow pulse (défaut true quand visible)
 */
const GlowDot = ({ size = 6, visible = true, pulse = true }) => {
  if (!visible) return null;
  return (
    <>
      <span
        style={{
          display: "inline-block",
          width: size,
          height: size,
          borderRadius: "50%",
          background: T.accent,
          boxShadow: `0 0 ${size}px ${Math.round(size * 0.8)}px ${T.accent}50`,
          animation: pulse ? "glowDotPulse 2s ease-in-out infinite" : "none",
          flexShrink: 0,
        }}
      />
      <style>{`
        @keyframes glowDotPulse {
          0%, 100% { opacity: 0.6; transform: scale(1); box-shadow: 0 0 4px 2px ${T.accent}4D; }
          50% { opacity: 1; transform: scale(1.3); box-shadow: 0 0 8px 4px ${T.accent}80; }
        }
      `}</style>
    </>
  );
};

export default GlowDot;
